import templateOnly from '@ember/component/template-only';

export type ToggleButtonVariant = 'default' | 'filter';

export interface ToggleButtonOption {
  count?: number;
  iconName?: string;
  label: string;
  value: string;
}

export interface ToggleButtonSignature {
  Args: {
    activeOption: string | undefined;
    options: ToggleButtonOption[];
    onChange: (optionValue: string) => void;
    variant?: ToggleButtonVariant;
  };
  Element: HTMLDivElement;
}

export default templateOnly<ToggleButtonSignature>();
